import { render, staticRenderFns } from "./SelectTipoVendedor.vue?vue&type=template&id=7107b7ca&"
import script from "./SelectTipoVendedor.vue?vue&type=script&lang=js&"
export * from "./SelectTipoVendedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports